<h1 mat-dialog-title>{{heading}}</h1>
<div mat-dialog-content>{{message}}</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>